import DialogAbout from './DialogAbout'

export { DialogAbout }
export default DialogAbout
